// Zdjęcia ze starej usługi zdjęć (ogłoszenia z pid, bez Cloudflare). Usługa odpowiada pustym 200 na brak pliku,
// więc w przeglądarce: zwykły <img> (bez /_next/image) i obraz zastępczy przy błędzie albo pustej odpowiedzi.
const API = process.env.NEXT_PUBLIC_IMAGE_SERVICE
const FALLBACK = '/fallback/list.png'
const PHOTO_PATH = /^\/api\/proxy\/photo\/[^/?#]+\/[^/?#]+$/

function isServicePhoto (src) {
    return typeof src === 'string' && Boolean(API) && src.startsWith(`${API}/photo/`)
}

// Adres zdjęcia usługi z parametru url dawnego /_next/image (pełny albo względny) albo null.
function servicePhotoTarget (url) {
    if (!API || typeof url !== 'string' || !url) return null
    let target
    try {
        target = new URL(url, API)
    } catch {
        return null
    }
    return target.origin === new URL(API).origin && PHOTO_PATH.test(target.pathname) ? target.href : null
}

// obraz już zakończony bez treści (np. błąd przed hydratacją, którego React nie zgłasza)
function isBroken (img) {
    return Boolean(img && img.complete && img.naturalWidth === 0 && img.getAttribute('src'))
}

function showFallback (img) {
    if (!img || img.dataset.fallback) return
    img.dataset.fallback = '1'
    img.removeAttribute('srcset')
    img.src = FALLBACK
}

export {
    FALLBACK,
    isBroken,
    isServicePhoto,
    servicePhotoTarget,
    showFallback,
}
